import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar } from '@angular/material/snack-bar';
import { sortLanguageCodes } from '../../_utils/utils';

@Component({
  selector: 'app-json-preview-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, MatTooltipModule],
  templateUrl: './json-preview-dialog.component.html',
  styleUrl: './json-preview-dialog.component.scss',
})
export class JsonPreviewDialogComponent {
  formattedJson: string = '';
  selectedLang: string;
  languages: string[];

  constructor(
    public dialogRef: MatDialogRef<JsonPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      templateName: string;
      templateData: { [lang: string]: any };
    },
    private snackBar: MatSnackBar
  ) {
    // Sort languages: English first, then alphabetical
    this.languages = sortLanguageCodes(Object.keys(data.templateData));
    // Default to English if available, otherwise first language
    this.selectedLang = this.languages.includes('en') ? 'en' : (this.languages[0] || 'en');
    this.updateFormattedJson();
  }

  selectLanguage(lang: string) {
    this.selectedLang = lang;
    this.updateFormattedJson();
  }

  updateFormattedJson() {
    const template = this.data.templateData[this.selectedLang];
    this.formattedJson = JSON.stringify(template, null, 2);
  }

  async copyToClipboard() {
    try {
      await navigator.clipboard.writeText(this.formattedJson);
      this.snackBar.open('JSON copied to clipboard', 'OK', { duration: 2000 });
    } catch (error) {
      this.snackBar.open('Failed to copy to clipboard', 'OK', {
        duration: 2000,
      });
    }
  }
}
